import { getFetchOrganisationContactPerson, postCreateOrganisationContactPerson, postFetchAllOrganisationContactPersons, postGetAllOrganisationContactPersons } from "src/api/queries/order-portal-bff";
import { useNotification } from "src/composables/useNotification";
import type { ContactFormData } from "src/components/form/ContactFields.vue";
import type { ContactPersonFilterDTO, CreateOrganisationContactPersonDTO, FetchOrganisationContactPersonResponse } from "src/api/models";
import type { PaginationParams } from "src/composables/ticket-entities/types";

export interface OrganisationContactPersonResponse extends ContactFormData {
  id: string;
  organisation: {
    id: string;
    name: string;
  };
}

export function useOrganisationContactPersonService() {
  const { showError } = useNotification();


  async function fetchOrganisationContactPerson(id: string): Promise<FetchOrganisationContactPersonResponse> {
    try {
      const response = await getFetchOrganisationContactPerson(id);
      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function fetchOrganisationContactPersons(filters?: ContactPersonFilterDTO, pagination?: PaginationParams) {
    try {
      const response = await postFetchAllOrganisationContactPersons(
        filters ?? {},
        {
          limit: pagination?.limit ?? 50,
          page: pagination?.page ?? 1,
        }
      );

      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function fetchContactPersonsByOrganisation(organisationId: string): Promise<FetchOrganisationContactPersonResponse[]> {
    try {
      const response = await postGetAllOrganisationContactPersons(organisationId);

      return response || [];
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function createOrganisationContactPerson(organisationContactPerson: CreateOrganisationContactPersonDTO): Promise<FetchOrganisationContactPersonResponse> {
    try {
      const response = await postCreateOrganisationContactPerson(organisationContactPerson);
      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  return {
    fetchOrganisationContactPersons,
    fetchContactPersonsByOrganisation,
    fetchOrganisationContactPerson,
    createOrganisationContactPerson
  };
}
